import { Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import { CompanyLogo, Logo, PersonWrapper } from './PersonInfo.style';

const PersonInfo = ({ personName, companyName, logo, className }) => {
  return (
    <PersonWrapper className={className}>
      <CompanyLogo>
        <Logo data={logo} fill sizes="42px" />
      </CompanyLogo>
      <Stack ml={1} justifyContent="flex-end">
        <Typography variant="body1" sx={{ fontSize: 14 }}>
          {personName}
        </Typography>
        <Typography variant="body1" sx={{ fontSize: 14, fontWeight: 'bold' }}>
          {companyName}
        </Typography>
      </Stack>
    </PersonWrapper>
  );
};

PersonInfo.propTypes = {
  className: PropTypes.string,
  logo: PropTypes.object,
  personName: PropTypes.string,
  companyName: PropTypes.string.isRequired,
};

PersonInfo.defaultProps = {
  logo: '',
  personName: '',
  companyName: '',
};

export default PersonInfo;
